import { gql, useMutation } from '@apollo/client';
import type { CreateLotTransferItem, CreateLotTransferItemVariables } from 'types/graphql';

const CREATE_LOT_TRANSFER_ITEM = gql`
  mutation CreateLotTransferItem($input: CreateLotTransferItemInput!) {
    createLotTransferItem(input: $input) {
      id
      lot { id slug metrics { unitsAvailable } warehouseId product { description }
        palletTags { id tagNumber cartonQuantity } }
      palletTagsOnTransferItem { palletTag { id tagNumber cartonQuantity } }
    }
  }
`;
export function useCreateLotTransferItem() {
  const [createLotTransferItem, { loading, error }] = useMutation<
    CreateLotTransferItem,
    CreateLotTransferItemVariables
  >(CREATE_LOT_TRANSFER_ITEM);
  return { createLotTransferItem, loading, error };
}
